import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import ReactApexChart from "react-apexcharts";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Documents } from ".";

interface TimeOnClientCollects {
  id: number;
  route: string;
  client: string;
  waitingTime: string;
  clientId: string;
}

export const ChartBar = ({ data }: Documents) => {
  const { getSizesComponent, setFontSize, componentProperty} =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const [total, setTotal] = useState<number>(0);
  const chartRefDft = useRef<ReactApexChart>(null);
  const { mode } = useParams();

  const [options, setOptions] = useState<ApexOptions | null>(null);
  const [series, setSeries] = useState<{ data: number[] }[] | null>(null);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-time-on-client-collects" });
    if (sizes.width < 345) {
      setFontSize({
        id: "chart-time-on-client-collects",
        width: sizes.width,
      });
    }
    setWidthChart(sizes.width);
  }, [
    parseInt(
      (
        window.document.querySelector(`#chart-time-on-client-collects`)
          ?.parentNode as HTMLElement
      ).style.width.slice(0, -2)
    ),
  ]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-time-on-client-collects" });
    if (dataChart && dataChart.length > 0) {
      if (dataChart.length <= 2 || sizes.height > dataChart.length * 35) {
        setHeightChart(sizes.height - 40);
      } else {
        setHeightChart(dataChart.length * 35);
      }
    } else {
      setHeightChart(sizes.height - 40);
    }
  }, [
    parseInt(
      (
        window.document.querySelector(`#chart-time-on-client-collects`)
          ?.parentNode as HTMLElement
      ).style.height.slice(0, -2)
    ), dataChart
  ]);


  function convertSecDatetime(secs: number) {
    if (secs % 3600 !== 0 && secs > 3600) {
      const hours =
        Math.floor(secs / 3600) < 10
          ? "0" + Math.floor(secs / 3600)
          : Math.floor(secs / 3600);
      const minutes =
        Math.floor((secs % 3600) / 60) < 10
          ? "0" + Math.floor((secs % 3600) / 60)
          : Math.floor((secs % 3600) / 60);
      return hours + "h" + minutes;
    } else if (secs >= 3600) {
      const hours =
        Math.floor(secs / 3600) < 10
          ? "0" + Math.floor(secs / 3600)
          : Math.floor(secs / 3600);
      return hours + "h";
    } else {
      const minutes =
        Math.floor(secs / 60) < 10
          ? "0" + Math.floor(secs / 60)
          : Math.floor(secs / 60);
      return minutes + "m";
    }
  }

  const getBarColor = (value: number, i: number): string => {
    if (value < parseInt(data.limit) * 60) {
      return "#90EE90";
      // switch (i % 6) {
      //   case 0:
      //     return "#f2c80f";
      //   case 1:
      //     return "#b2b2b3";
      //   case 2:
      //     return "#9fe2dc";
      //   case 3:
      //     return "#fe9667";
      //   case 4:
      //     return "#a66999";
      //   case 5:
      //   default:
      //     return "#3599b8";
      // }
    } else {
      return "#fd6763";
    }
  };

  useEffect(() => {
    if(widthChart === getSizesComponent({ id: "chart-time-on-client-collects" }).width && 
    heightChart === getSizesComponent({ id: "chart-time-on-client-collects" }).height) return 
    const client: string[] = [],
      waitingTime: number[] = [],
      waitingTimeFmt: string[] = [],
      routeId: number[] = [];
    const sizes = getSizesComponent({ id: "chart-time-on-client-collects" });
    data.timeOnClient.forEach((route: TimeOnClientCollects) => {
      routeId.push(route.id);
      client.push(route.route + ": " + route.clientId + " " + route.client);
      waitingTime.push(parseInt(route.waitingTime));
      waitingTimeFmt.push(convertSecDatetime(parseInt(route.waitingTime)));
    });
    if (waitingTime && waitingTime.length !== 0) {
      const fakesCol = Math.floor(sizes.height / waitingTime.length / 230);
      if (fakesCol > 0) {
        for (let i = 1; i <= fakesCol; i++) {
          waitingTime.push(0);
        }
      }
    }
    loadDataChart(waitingTime, waitingTimeFmt, client, data.count, routeId);
  }, [data]);

  const loadDataChart = async (
    ctdataChart: number[],
    cldataChartFormatted: string[],
    ctClient: string[],
    ctTotal: number,
    ctRoute: number[],
  ) => {
    setDataChart(ctdataChart);
    setTotal(ctTotal);
    setSeries([
      {
        data: ctdataChart,
      },
    ]);
    loadOptions(ctdataChart, ctClient, cldataChartFormatted, ctRoute);
  };

  async function loadOptions(
    dataChart: number[],
    labels: string[],
    dataChartFormatted: string[],
    routes: number[]
  ) {
    setOptions({
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            if (
              mode === "view" &&
              componentProperty({
                id: "chartTimeOnClientCollects",
                property: "redirect",
              })
            ) {
              window.open(
                `${process.env.REACT_APP_COMPROVEI_URL}/routes/details/${
                  routes[config.dataPointIndex]
                }`,
                "_blank"
              );
            }
          },
        },
      },
      plotOptions: {
        bar: {
          barHeight: "80%",
          distributed: true,
          horizontal: true,
          dataLabels: { position: "bottom" },
        },
      },
      dataLabels: {
        enabled: true,
        textAnchor: "start",
        formatter: function (val, opt) {
          if (labels[opt.dataPointIndex]) {
            return (
              labels[opt.dataPointIndex] +
              ":  " +
              dataChartFormatted[opt.dataPointIndex]
            );
          }
          return "";
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: { position: "bottom" },
          },
        },
      ],
      yaxis: {
        labels: {
          show: false,
        },
      },
      xaxis: {
        labels: {
          show: false,
        },
        max: Math.max(...dataChart),
        range: 7,
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      labels: labels,
      tooltip: { enabled: false },
      legend: { show: false },
      colors: dataChart.map((item, i) => getBarColor(item, i)),
      annotations: {
        xaxis: [
          {
            x: parseInt(data.limit) * 60,
            borderColor: "#FFA510",
            strokeDashArray: 0,
            borderWidth: 5,
          },
        ],
      },
    });
    setCompleteRequisition(true);
  }

  return completeRequisition && series && options ? (
    <div className="h100 w100">
      <HeaderComponent
        title={`Tempo no Cliente - Coletas ${total}`}
        clickable={componentProperty({
          id: "chartTimeOnClientCollects",
          property: "redirect",
        })}
        id="chart-time-on-client-collects"
        width={widthChart}
      />
      <div
        id={
          dataChart &&
          (dataChart.length <= 10 ||
            getSizesComponent({ id: "chart-time-on-client-collects" }).height >
              dataChart.length * 35)
            ? "fixedBox"
            : "scrollBox"
        }
      >
        <div id="chart">
          <ReactApexChart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
            ref={chartRefDft}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics />
  );
};
